import type { TaskDto } from '@werft/contracts';
import { useSyncExternalStore } from 'react';

/**
 * ADR 0115: „Abschließen und nächsten Schritt anlegen …“ öffnet einen kleinen Entwurf (Startpaket: nur dieser Speicher;
 * das Fenster selbst wird erst beim Öffnen geladen). `onCreated` bekommt die neue Aufgabe (z. B. zum Öffnen).
 */
export interface NextStepRequest {
  task: TaskDto;
  onCreated?: (next: TaskDto) => void;
}

let current: NextStepRequest | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function openNextStep(task: TaskDto, onCreated?: (next: TaskDto) => void) {
  current = { task, ...(onCreated ? { onCreated } : {}) };
  emit();
}

export function closeNextStep() {
  current = null;
  emit();
}

export function useNextStep(): NextStepRequest | null {
  return useSyncExternalStore(
    (l) => (listeners.add(l), () => listeners.delete(l)),
    () => current,
  );
}
